export default {
  "wt-button": "_wt-button_1rcu3e2_1",
  "wt-button_busy": "_wt-button_busy_1rcu3e2_60",
  "wt-button_theme_light": "_wt-button_theme_light_1rcu3e2_74",
  "wt-button_disabled": "_wt-button_disabled_1rcu3e2_77",
  "wt-button_theme_dark": "_wt-button_theme_dark_1rcu3e2_78",
  "wt-button_align-icon_right": "_wt-button_align-icon_right_1rcu3e2_89",
  "wt-button_size_m": "_wt-button_size_m_1rcu3e2_96",
  "wt-button_narrow": "_wt-button_narrow_1rcu3e2_103",
  "wt-button_size_s": "_wt-button_size_s_1rcu3e2_108",
  "wt-button_size_xs": "_wt-button_size_xs_1rcu3e2_120",
  "wt-button_without-text": "_wt-button_without-text_1rcu3e2_138",
  "wt-button_with-icon": "_wt-button_with-icon_1rcu3e2_165",
  "wt-button_flat_right": "_wt-button_flat_right_1rcu3e2_177",
  "wt-button_flat_left": "_wt-button_flat_left_1rcu3e2_182",
  "wt-button_mode_primary": "_wt-button_mode_primary_1rcu3e2_187",
  "wt-button__busy-icon": "_wt-button__busy-icon_1rcu3e2_194",
  "wt-button_mode_black": "_wt-button_mode_black_1rcu3e2_280",
  "wt-button_mode_contrast": "_wt-button_mode_contrast_1rcu3e2_281",
  "wt-button_highlighted": "_wt-button_highlighted_1rcu3e2_331",
  "wt-button_mode_transparent": "_wt-button_mode_transparent_1rcu3e2_395",
  "wt-button_mode_outline": "_wt-button_mode_outline_1rcu3e2_440",
  "wt-button_mode_nude": "_wt-button_mode_nude_1rcu3e2_602",
  "wt-button__icon": "_wt-button__icon_1rcu3e2_693"
};